import { render } from "./CommentSection.vue?vue&type=template&id=ef900efc&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"

import "./CommentSection.vue?vue&type=style&index=0&id=ef900efc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef900efc"]])

export default __exports__